import { floor } from 'lodash';
import { useMemo } from 'react';

import { useTotalPolicySold } from '../../finish2/hooks/useTotalPolicySold';

export const PolicySoldNumber = () => {
  const { allTimesCount } = useTotalPolicySold();

  const numberText = useMemo(() => {
    if (!allTimesCount) return null;

    if (allTimesCount > 1000 * 10) {
      return `${floor(allTimesCount / 1000, -1)}K`;
    }
    return floor(allTimesCount, -1);
  }, [allTimesCount]);

  if (!allTimesCount) return null;

  return <span>{numberText}</span>;
};

export const PolicySoldLabel = () => {
  const { allTimesCount } = useTotalPolicySold();
  if (!allTimesCount) return null;

  return <span>Policies sold</span>;
};
